export default function EmbargoedWatermark() {
  return (
    <div role="presentation" className="embargoed-watermark">
      EMBARGOED
    </div>
  );
}
